module.exports = __webpack_public_path__ + "static/media/pen-icon-white.a34977c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pen-icon-white.svg
// module id = 1224
// module chunks = 0